<div *ngIf="!eFormStatus" class="badge">
  <mat-icon class="badge-icon" *ngIf="!!icon">{{ icon }}</mat-icon>
  {{ text }}
</div>

<div *ngIf="eFormStatus && isComplete" class="status-badge-complete">
  <mat-icon class="badge-icon" *ngIf="!!icon">{{ icon }}</mat-icon>
  {{ text }}
</div>

<div *ngIf="eFormStatus && !isComplete" class="status-badge-incomplete">
  <mat-icon class="badge-icon" *ngIf="!!icon">{{ icon }}</mat-icon>
  {{ text }}
</div>
